'use client';

import { ReactNode } from 'react';
import { usePathname } from '@/lib/routing';

// Routes where the footer should be hidden (locale prefix already stripped by usePathname).
const HIDDEN_PREFIXES = ['/account'];

interface ConditionalFooterProps {
  children: ReactNode;
}

/**
 * Hides the footer on account pages while keeping it on the rest of the (app) zone.
 * FooterV2 stays a server component — it's passed through as children.
 */
export function ConditionalFooter({ children }: ConditionalFooterProps) {
  const pathname = usePathname();
  const hidden = HIDDEN_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );

  if (hidden) return null;

  return <>{children}</>;
}
